import type {
  AccountInfo,
  IPublicClientApplication,
  SilentRequest,
} from '@azure/msal-browser';
import { tenantIdMatchesHomeTenant } from '@azure/msal-common';
import { runtimeConfig } from '@/runtimeConfig';

export const msalScopes = runtimeConfig.MsalScopes.Or(
  `api://${runtimeConfig.MsalClientId.asString()}/.default`,
)
  .trim()
  .split(',')
  .map((scope) => scope.trim());

export const silentRequest = (account: AccountInfo): SilentRequest => ({
  scopes: msalScopes,
  account,
  prompt: 'none',
});

export const selectAccountAndTryToAcquireTokenFunction = async (
  instance: IPublicClientApplication,
): Promise<string | null> => {
  const tryGetTokenSilentlyAndLogin = async (
    accounts: AccountInfo[],
  ): Promise<string | null> => {
    for (const account of accounts) {
      const result = await instance
        .acquireTokenSilent(silentRequest(account))
        .catch(() => null);
      if (result?.accessToken) {
        instance.setActiveAccount(account);
        return result.accessToken;
      }
    }
    return null;
  };

  const activeAccount = instance.getActiveAccount();
  if (activeAccount !== null) {
    return await tryGetTokenSilentlyAndLogin([activeAccount]);
  }

  const tenantAccounts = instance
    .getAllAccounts()
    .filter((account) =>
      tenantIdMatchesHomeTenant(account.tenantId, account.homeAccountId),
    );

  if (tenantAccounts.length === 0) {
    return null;
  }

  return await tryGetTokenSilentlyAndLogin(tenantAccounts);
};
